/**
 * Barrel exports for the dock system.
 */
export { DockableLayout } from "./dockable-layout"
export { LayoutProvider, useLayoutPanels } from "./layout-context"
export { getDefaultLayoutJson, PANEL_COMPONENTS, LAYOUT_STORAGE_KEY } from "./layout-model"
export type { PanelComponent } from "./layout-model"
